export default __webpack_public_path__ + "static/media/Visitors.88a73027.svg";